<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item label="房源编号" prop="room_num"><br>
				<el-select style="width: 100%;" v-model="room_num" placeholder="请选择房间" @change="changeselect">
					<el-option v-for=" item in options" :key="item.id" :label="item.room_num" :value="item.room_num">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>

		</el-form>
		<div>
			<span>备注</span>
			<el-input style="margin-top: 1rem;" type="textarea" :rows="2" placeholder="请输入备注" v-model="inputmodel.remark">
			</el-input>
		</div>
		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>
<script>
	import {
		up_img,
		contract_list,
		contract_relet_create,
		house_list
	} from "@/api/api.js"
	import {
		BASEURL
	} from "@/Utils/request.js";

	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '合同ID',
					model: 'cid'
				}, {
					name: '续租月数(月)',
					model: 'month'
				}, {
					name: '续租天数(天)',
					model: 'day'
				}, ],
				inputmodel: {
					cid: '',
					month: '',
					day: '',
					remark: '无'
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 0,
					rent_status: 0
				},
				room_num: ''

			}
		},
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					if (this.inputmodel.cid === '') {
						this.$message({
							message: '合同编号不能为空',
							type: 'error'
						});
						return
					}
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							const params = {
								...this.inputmodel,
								cid: parseInt(this.inputmodel.cid, 10),
								month: parseInt(this.inputmodel.month, 10)
							};
							// 👆 这里确保 cid/month/day 都是整数

							contract_relet_create(params).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.room_num = ''
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						} else {
							this.$message({
								message: '表格内容不能为空',
								type: 'error'
							});
							return
						}
					})
				} else {
					this.room_num = ''
					this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
			// 多选框
			changeselect(value) {
				// value 是被选中的房间号

				// 查找对应的 item
				const selectedItem = this.options.find(item => item.room_num === value);
				if (selectedItem) {
					console.log('Selected item:', selectedItem);
					this.inputmodel.cid = selectedItem.id;


				}
			},
			handleRemove(file, fileList) {
				console.log(111111, file, fileList)
			},
			handlePreview(file) {
				// console.log(file)
				console.log('点击', this.ruleForm.file)
			}
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			contract_list({
				limit: 0,
				status: 1
			}).then(res => {
				const _res = res.data.list
				this.options = _res;
			})
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}
</style>